/* dfx-cart.js - DFX Cart, the in-house cart drawer (sections/dfx-cart.liquid), 2026-10-02.
 * Sleepyhead copy (2026-10-06) of the Duroflex file; differences: no Outfit font (the theme forces Migrena Grotesque),
 * "You may also like" fills up from the next recommendation intent, Shopify checkout for visitors outside India,
 * option picker looks like the PDP "Select options" popup, analytics events (cart_*; see emit()).
 *
 * <dfx-cart> offers the cart interface product-form.js / quick-add.js call (open, renderContents,
 * getSectionsToRender, setActiveElement). Liquid renders everything the server knows; this file adds:
 *  - coupons: Apply puts the code on the cart through Shopify (cart/update.js `discount`), so only a code Shopify
 *    accepts shows as applied, with Shopify's own saving; GoKwik checkout reads it from the cart. The section's coupon
 *    blocks only advertise codes (their saving there is an estimate).
 *  - Payment Offers / EMI tabs: GoKwik's offers API (POST https://gkx.gokwik.co/v3/kwik-cart/widget-offers with
 *    x-shop-domain + the cart + any requestId + platform), fetched on open and again when the cart total changes;
 *    on any failure the two tabs stay hidden. Credited "Powered by GoKwik" under those tabs.
 *  - quantity / remove / "You may also like" adds through the Cart AJAX API with Section Rendering.
 * No scroll lock and no history entries (the page must stay scrollable; see the head style guard).
 */
(function () {
  if (customElements.get('dfx-cart')) return;

  var GK_URL = 'https://gkx.gokwik.co/v3/kwik-cart/widget-offers';
  // ponytail: GoKwik's own config reports platform "checkout_1.0" for this store; update if GoKwik moves it.
  var GK_PLATFORM = 'checkout_1.0';
  var GK_VALIDATE_URL = 'https://gkx.gokwik.co/v3/kwik-cart/discount/validate';   // only for the "why not" wording
  var CODE_COOKIE = 'discount_code';   // Shopify's /discount/CODE cookie; the drawer itself kept codes here until 12 Oct 2026
  var CARRIED = 'dfx_cart_carried';    // sessionStorage: cookie code already tried on the cart
  var CHEERED = 'dfx_cart_cheered';   // sessionStorage: achievements already celebrated
  var CODE_RE = /^[A-Za-z0-9_-]{2,40}$/;
  // Same output as Liquid's money_without_currency | prepend: '₹' in the section (₹146,160.00).
  var num = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  var IC_TAG = '<svg class="dfx-ic" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  var IC_PCT_TEAL = '<svg class="dfx-ic" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4FA88E" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M9 15l6-6"/><circle cx="9.5" cy="9.5" r="1"/><circle cx="14.5" cy="14.5" r="1"/><circle cx="12" cy="12" r="9"/></svg>';
  var IC_INFO = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M11 9h2V7h-2m1 13c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8m0-18a10 10 0 100 20 10 10 0 000-20m-1 15h2v-6h-2z"/></svg>';
  var IC_PCT = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M18.5 3.5l2 2-15 15-2-2 15-15M7 4a3 3 0 110 6 3 3 0 010-6m10 10a3 3 0 110 6 3 3 0 010-6"/></svg>';
  var IC_CARD = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M20 8H4V6h16m0 12H4v-6h16m0-8H4c-1.1 0-2 .9-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2"/></svg>';
  var IC_DOWN = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M7.4 8.6L12 13.2l4.6-4.6L18 10l-6 6-6-6z"/></svg>';

  function money(paise) { return '₹' + num.format((Number(paise) || 0) / 100); }
  // Whole rupees without the .00 (the 'saved so far' badge next to Estimated Total).
  function moneyShort(paise) { var p = Math.round(Number(paise) || 0); return p % 100 ? money(p) : '₹' + num.format(p / 100).replace(/\.00$/, ''); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function readJson(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
  }
  function setCookie(name, value) {
    document.cookie = name + '=' + (value || '') + '; path=/; max-age=' + (value ? 86400 : 0) + '; SameSite=Lax';
  }
  function camel(o) {
    if (Array.isArray(o)) return o.map(camel);
    if (o && typeof o === 'object') {
      var r = {};
      Object.keys(o).forEach(function (k) { r[k.replace(/_([a-z])/g, function (m, c) { return c.toUpperCase(); })] = camel(o[k]); });
      return r;
    }
    return o;
  }
  function requestId() {
    try {
      var id = sessionStorage.getItem('dfx-gk-rid');
      if (!id) { id = crypto.randomUUID(); sessionStorage.setItem('dfx-gk-rid', id); }
      return id;
    } catch (e) { return String(Date.now()) + Math.random().toString(16).slice(2); }
  }
  function https(u) { return /^https:\/\//.test(String(u || '')) ? u : ''; }
  // Coupon saving in paise from a section block: percent of the cart total (after automatic discounts) or a
  // flat amount, 0 below the minimum, never above the cap or the total.
  function saving(c, total, offers) {
    if (!c || total < c.min || blockedBy(c, offers)) return 0;
    var s = c.kind === 'flat' ? Math.round(c.value * 100) : Math.round(total * c.value / 100);
    if (c.cap > 0) s = Math.min(s, c.cap);
    return Math.max(0, Math.min(s, total));
  }
  // Shopify keeps only the bigger of two discounts that don't combine; the hamper offer is always bigger.
  function blockedBy(c, offers) { return !c.combines && offers && offers.length ? offers[0].t : ''; }
  function imgUrl(src, w) {
    if (!src || !/^(https:)?\/\//.test(src)) return '';
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  // One "You may also like" card from an Ajax product (recommendations JSON); same markup as the Liquid card.
  function fbtCard(p) {
    var vs = p.variants || [], v = vs.filter(function (x) { return x.available && !/custom/i.test(x.title); })[0] || vs[0];
    if (!v) return '';
    var multi = !(vs.length === 1 && /^Default Title$/.test(vs[0].title));
    var off = v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
    var img = imgUrl(p.featured_image, 200);
    var data = multi ? JSON.stringify({
      title: p.title,
      options: (p.options || []).map(function (o) { return { n: o.name, v: o.values }; }),
      variants: vs.map(function (x) { return { id: x.id, t: x.title, o: x.options, p: x.price, c: x.compare_at_price || 0, a: x.available }; })
    }).replace(/</g, '\\u003c') : '';
    return '<div class="dfx-cart__fbt-card" data-dfx-fbt data-src="' + esc(p.dfxSrc || '') + '" data-pid="' + esc(p.id) + '">' +
      '<a href="' + esc(p.url) + '" class="dfx-cart__fbt-img" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</a>' +
      '<div class="dfx-cart__fbt-info"><a href="' + esc(p.url) + '" class="dfx-cart__fbt-name">' + esc(p.title) + '</a>' +
      (multi ? '<button type="button" class="dfx-cart__fbt-pick" data-dfx-fbt-pick aria-haspopup="dialog"><span data-dfx-fbt-label>' + esc(v.title) + '</span>' + IC_DOWN + '</button>' +
        '<script type="application/json" data-dfx-fbt-data>' + data + '<\/script>' : '') +
      '<span class="dfx-cart__fbt-prices"><span class="dfx-cart__price" data-dfx-fbt-price>' + money(v.price) + '</span>' +
      '<s class="dfx-cart__strike" data-dfx-fbt-compare' + (off ? '' : ' hidden') + '>' + money(v.compare_at_price || 0) + '</s></span></div>' +
      '<div class="dfx-cart__fbt-foot"><span class="dfx-cart__fbt-off" data-dfx-fbt-off' + (off ? '' : ' hidden') + '>' + off + '% off</span>' +
      '<button type="button" class="dfx-cart__fbt-add" data-dfx-fbt-add="' + v.id + '">+ Add</button></div></div>';
  }
  function publishCart(data) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dfx-cart', cartData: data });
      }
    } catch (e) {}
  }
  // Analytics, same channels as the popup events (popup-shared-utils track()): GTM dataLayer + GA4 gtag. Custom
  // cart_* names, not GA4's add_to_cart/begin_checkout, which Shopify's own pixels already send. Item fields are flat
  // params (GA4 only reads an items[] array on its ecommerce events). Money in rupees.
  function emit(name, params) {
    // dataLayer gets its own copy: gtag.js stamps gtm.uniqueEventId onto pushed objects, which leaked as ep.gtm.
    var p = Object.assign({ event_source: 'sh_cart', currency: 'INR' }, params);
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) {}
  }
  function rupees(paise) { return Math.round(Number(paise) || 0) / 100; }
  function variantName(t) { return t && t !== 'Default Title' ? String(t) : ''; }
  // A cart line's item fields, from the data-* the section stamps on its card; qty = units this event is about.
  function cardItem(card, qty) {
    var d = card.dataset;
    return { item_id: d.vid, product_id: d.pid, item_name: d.name, item_variant: variantName(d.variant), price: rupees(d.price), quantity: qty };
  }

  class DfxCart extends HTMLElement {
    connectedCallback() {
      if (this.wired) return;
      this.wired = true;
      var self = this;
      this.cfg = readJson(this.querySelector('[data-dfx-cart-config]')) || { coupons: [] };
      this.cfg.coupons = this.cfg.coupons || [];
      this.sheet = this.querySelector('[data-dfx-offers]');
      this.tab = 'coupons';
      this.err = '';
      this.addEventListener('click', function (e) { self.onClick(e); });
      this.addEventListener('change', function (e) { self.onChange(e); });
      this.addEventListener('input', function (e) {
        var f = e.target.closest('[data-dfx-form]');
        if (f) f.querySelector('button').disabled = !e.target.value.trim();
      });
      this.addEventListener('submit', function (e) {
        var f = e.target.closest('[data-dfx-form]');
        if (!f) return;
        e.preventDefault();
        self.applyCode(f.elements.code.value, 'typed');
      });
      this.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (self.pick) self.closePicker(); else if (!self.sheet.hidden) self.closeOffers(); else self.close('esc');
      });
      document.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('#cart-icon-bubble, [data-dfx-open-cart]');
        if (!t) return;
        e.preventDefault();
        self.open(t);
      });
      // Where the next add to cart comes from (product-form forms only), for cart_item_added.
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f.closest || !f.closest('product-form')) return;
        self.addSource = f.closest('quick-add-modal') ? 'quick_add' : f.closest('.sticky-atc-wrapper') ? 'sticky_atc' : 'pdp';
      }, true);
      document.querySelectorAll('#cart-icon-bubble').forEach(function (a) {
        a.setAttribute('role', 'button');
        a.setAttribute('aria-haspopup', 'dialog');
      });
      // GoKwik checkout falls back to a `coupon_applied` cookie when `discount_code` is empty. Only the old side cart
      // wrote it, so a leftover one would re-apply a code the shopper can no longer see or remove: clear it.
      if (cookie('coupon_applied')) setCookie('coupon_applied', '');
      // dfx-combo-offer edits the cart after our own calls (gift lines follow the mattress quantity).
      document.addEventListener('dfx:combo-synced', function () { self.refresh(); });
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, function (d) {
            var src = d && d.source;
            if (src !== 'dfx-cart' && src !== 'product-form' && src !== 'dfx-combo') self.refresh();
          });
        }
      } catch (e) {}
      window.addEventListener('gokwikLoaded', function () {
        try { gokwikSdk.on('modal_closed', function () { self.resetCheckout(); }); } catch (e) {}
      });
      this.paint();
      this.addEventListener('scroll', function (e) {
        if (e.target.parentNode && e.target.parentNode.classList && e.target.parentNode.classList.contains('dfx-cart__rail')) self.rails();
      }, true);
    }

    /* ---------- Dawn interface ---------- */
    setActiveElement(el) { this.activeElement = el; }
    getSectionsToRender() { return [{ id: this.dataset.section }]; }
    renderContents(state) {
      var before = this.cart ? this.cart.count : 0;
      var html = state && state.sections && state.sections[this.dataset.section];
      if (html) this.apply(html); else this.refresh();
      // state = the /cart/add.js line (product-form, quick add); quantity = units this add put in the cart
      if (state && state.variant_id) {
        this.track('cart_item_added', { source: this.addSource || 'other', item_id: String(state.variant_id), product_id: String(state.product_id),
          item_name: state.product_title, item_variant: variantName(state.variant_title), price: rupees(state.final_price),
          quantity: Math.max(1, (this.cart ? this.cart.count : 0) - before) });
      }
      this.addSource = null;
      this.openVia = 'add_to_cart';
      this.open();
    }

    // Every event also carries the cart value (rupees, after the coupon) and item count at that moment.
    track(name, params) {
      var c = this.cart || {};
      emit(name, Object.assign({ cart_value: rupees(c.total || 0), item_count: c.count || 0 }, params));
    }

    open(trigger) {
      if (trigger) this.activeElement = trigger;
      var via = this.openVia || (trigger ? 'icon' : 'other');
      this.openVia = null;
      if (this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      this.openedAt = Date.now();
      this.track('cart_opened', { trigger: via });
      this.burst();
      this.loadOffers();
      var panel = this.querySelector('.dfx-cart__panel');
      setTimeout(function () {
        if (typeof trapFocus === 'function') trapFocus(panel, panel.querySelector('.dfx-cart__x') || panel);
        else panel.focus();
      }, 50);
    }

    close(method) {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.closeOffers();
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      this.track('cart_closed', { close_method: method || 'other', time_open_sec: Math.round((Date.now() - (this.openedAt || Date.now())) / 1000) });
    }

    /* ---------- rendering ---------- */
    refresh() {
      var self = this;
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(function () {
        var id = self.dataset.section;
        fetch(location.pathname + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (j) { if (j && j[id]) self.apply(j[id]); })
          .catch(function () {});
      }, 60);
    }

    apply(html) {
      this.closePicker();
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dfx-cart-body]');
      var body = this.querySelector('[data-dfx-cart-body]');
      if (!fresh || !body) return;
      var sc = body.querySelector('.dfx-cart__scroll');
      var top = sc ? sc.scrollTop : 0;
      body.innerHTML = fresh.innerHTML;
      sc = body.querySelector('.dfx-cart__scroll');
      if (sc) sc.scrollTop = top;
      this.paint();
      if (this.classList.contains('is-open')) this.loadOffers();
    }

    // Everything that depends on the cookie or on GoKwik, painted over the Liquid output.
    paint() {
      this.cart = readJson(this.querySelector('[data-dfx-cart-data]')) || { total: 0, strike: 0, count: 0, offers: [] };
      this.bubble(this.cart.count);
      var code = this.code();
      var c = this.coupon(code);
      // Shopify's cart total is already net of an applied code; `saved` is what the coupon row and the events show.
      this.saved = code ? Number(this.cart.codes[0].a) || 0 : 0;
      this.paintCoupon(code, c);
      this.carry(code);

      var total = this.cart.total;
      var strike = this.cart.strike;
      var t = this.querySelector('[data-dfx-total]');
      if (t) t.textContent = money(total);
      var s = this.querySelector('[data-dfx-total-strike]');
      if (s) s.hidden = strike <= total;
      var off = this.querySelector('[data-dfx-total-off]');
      if (off) off.textContent = strike > total ? '(' + Math.round((strike - total) * 100 / strike) + '% OFF)' : '';
      var rib = this.querySelector('[data-dfx-saved]');
      if (rib) {
        rib.hidden = strike - total <= 0;
        var amt = rib.querySelector('[data-dfx-saved-amt]');
        if (amt) amt.textContent = moneyShort(strike - total);
      }
      this.countBadge();
      this.paintOffers();
      this.fitManual();
      this.loadRecs();
      this.cheer();
      this.rails();
      this.markArm();
    }

    // Rollouts experiment (Oct 2026): this theme is the sh_cart (native cart) arm. The cart attribute rides through GoKwik
    // checkout into the order's note attributes, so orders split by arm; KwikCart-arm orders carry GoKwik-Cart=true.
    markArm() {
      if (!this.cart.count || this.cart.arm === 'sh_cart' || this.armSent) return;
      this.armSent = true;
      fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _cart_type: 'sh_cart' } }) }).catch(function () {});
    }

    // Sideways rows (offer banners, "You may also like"): the arrows show only where there is more to scroll to.
    rails() {
      this.querySelectorAll('.dfx-cart__rail').forEach(function (r) {
        var row = r.firstElementChild, max = row.scrollWidth - row.clientWidth;
        r.classList.toggle('can-prev', row.scrollLeft > 2);
        r.classList.toggle('can-next', row.scrollLeft < max - 2);
      });
    }

    /* ---------- confetti: once per offer, coupon or gold voucher slab per visit ---------- */
    cheer() {
      if (!this.cfg.confetti) return;
      var keys = (this.cart.offers || []).map(function (o) { return 'o:' + o.t; });
      if (this.saved > 0) keys.push('c:' + this.code().toUpperCase());
      this.querySelectorAll('.dfx-cart__gv-stop.is-hit b').forEach(function (b) { keys.push('gv:' + b.textContent); });
      var first = !this.cheered;
      if (first) {   // what the page loaded with is not news
        try { this.cheered = JSON.parse(sessionStorage.getItem(CHEERED)) || []; } catch (e) { this.cheered = []; }
      }
      var seen = this.cheered, fresh = keys.filter(function (k) { return seen.indexOf(k) < 0; });
      if (!fresh.length) return;
      this.cheered = seen.concat(fresh);
      try { sessionStorage.setItem(CHEERED, JSON.stringify(this.cheered)); } catch (e) {}
      if (first) return;
      this.cheerDue = true;   // fired now if open, else when the drawer opens (add to cart renders before it opens)
      if (this.classList.contains('is-open')) this.burst();
    }

    burst() {
      if (!this.cheerDue) return;
      this.cheerDue = false;
      if (Date.now() - (this.lastBurst || 0) < 4000) return;   // hamper + gifts + slab land in quick renders: one burst
      this.lastBurst = Date.now();
      var panel = this.querySelector('.dfx-cart__panel');
      var run = function () {
        var r = panel.getBoundingClientRect();
        window.confetti({ particleCount: 90, spread: 75, startVelocity: 32, ticks: 160, zIndex: 2147483647, disableForReducedMotion: true,
          origin: { x: (r.left + r.width / 2) / window.innerWidth, y: 0.3 } });
      };
      if (window.confetti) return void setTimeout(run, 250);
      if (!this.confettiJs) {
        this.confettiJs = document.createElement('script');
        this.confettiJs.src = this.cfg.confettiSrc;
        document.head.appendChild(this.confettiJs);
      }
      this.confettiJs.addEventListener('load', function () { setTimeout(run, 150); }, { once: true });
    }

    /* ---------- "You may also like" from Search & Discovery ---------- */
    loadRecs() {
      var rec = this.cfg.rec || {}, pid = this.cart.recPid, self = this;
      if (!pid || !rec.source || rec.source === 'manual') return;
      var key = rec.source + ':' + pid + ':' + (this.cart.inCart || []).join(',') + ':' + (this.cart.dims || '');
      this.recCache = this.recCache || {};
      if (this.recCache[key]) return this.paintRecs(this.recCache[key]);
      var intents = rec.source === 'complementary_related' ? ['complementary', 'related'] : [rec.source];
      var want = (Number(rec.limit) || 5), inCart = (this.cart.inCart || []).map(Number);
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      // Complementary first; related fills the row up (most products have only one or two complementary picks).
      var got = [];
      var next = function (n) {
        if (n >= intents.length || got.length >= want) {
          self.recCache[key] = got;
          if (got.length && self.cart && self.cart.recPid === pid) self.paintRecs(got);
          return;
        }
        fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=' + (want + inCart.length) + '&intent=' + intents[n], { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (j) {
            ((j && j.products) || []).forEach(function (p) {
              p = self.fit(Object.assign({ dfxSrc: intents[n] }, p));
              if (p && got.length < want && p.available && inCart.indexOf(Number(p.id)) < 0 && !got.some(function (g) { return g.id === p.id; })) got.push(p);
            });
            next(n + 1);
          })
          .catch(function () { next(n + 1); });
      };
      next(0);
    }

    // Protectors are one product per size and colour, but Search & Discovery / manual picks are per product, so a King
    // mattress would get the Single protector. Like the PDP's "People also bought together" (custom-complimentory.liquid),
    // a protector pick (SKU SHPRO + L W H + colour) becomes the same colour in the cart mattress's size (cart.prot).
    // Returns the pick unchanged when there is no mattress size to match, null to drop it (no such size / sold out).
    fit(p) {
      var prot = this.cart && this.cart.prot, v = p && p.variants && p.variants[0], sku = String((v && v.sku) || '');
      if (!prot || sku.slice(0, 5) !== 'SHPRO' || sku.length < 17) return p;
      var m = prot[sku.slice(17, 25)];
      return m ? Object.assign({ dfxSrc: p.dfxSrc }, m) : null;
    }

    // Same swap for the Liquid-rendered ("manual") picks; Ajax picks get it in loadRecs.
    fitManual() {
      var self = this, row = this.querySelector('[data-dfx-fbt-row]'), inCart = (this.cart.inCart || []).map(Number);
      if (!row || !this.cart.prot) return;
      row.querySelectorAll('[data-dfx-fbt][data-src="manual"][data-sku^="SHPRO"]').forEach(function (card) {
        var p = { dfxSrc: 'manual', variants: [{ sku: card.getAttribute('data-sku') }] }, m = self.fit(p);
        if (m === p) return;
        var dup = m && row.querySelector('[data-dfx-fbt][data-pid="' + m.id + '"]');
        if (!m || inCart.indexOf(Number(m.id)) >= 0 || (dup && dup !== card)) return card.remove();
        if (String(m.id) !== card.getAttribute('data-pid')) card.outerHTML = fbtCard(m);
      });
      row.closest('[data-dfx-fbt-box]').hidden = !row.children.length;
    }

    paintRecs(ps) {
      var box = this.querySelector('[data-dfx-fbt-box]'), row = box && box.querySelector('[data-dfx-fbt-row]');
      if (!row || !ps.length) return;   // nothing found: the manual list Liquid rendered stays
      row.innerHTML = ps.map(fbtCard).join('');
      box.hidden = false;
      this.rails();
    }

    bubble(count) {
      document.querySelectorAll('#cart-icon-bubble').forEach(function (a) {
        var b = a.querySelector('.cart-count-bubble');
        if (!count) { if (b) b.remove(); return; }
        if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
        b.innerHTML = (count < 100 ? '<span aria-hidden="true">' + count + '</span>' : '') +
          '<span class="visually-hidden">' + count + ' items</span>';
      });
    }

    /* ---------- coupons ---------- */
    // The discount code Shopify has applied on this cart (cart-data "codes", from cart.discount_applications).
    code() {
      var cs = this.cart && this.cart.codes;
      return cs && cs.length ? String(cs[0].c) : '';
    }

    coupon(code) {
      if (!code) return null;
      var lc = code.toLowerCase();
      for (var i = 0; i < this.cfg.coupons.length; i++) {
        if (String(this.cfg.coupons[i].code).toLowerCase() === lc) return this.cfg.coupons[i];
      }
      return null;
    }

    formHtml(sheet) {
      return '<form class="dfx-cart__form' + (sheet ? ' is-sheet' : '') + '" data-dfx-form novalidate>' +
        '<input name="code" type="text" placeholder="Enter coupon code" autocomplete="off" autocapitalize="characters" maxlength="40" aria-label="Coupon code">' +
        '<button type="submit" class="dfx-cart__btn" disabled>Apply</button></form>' +
        '<p class="dfx-cart__err" role="alert"' + (this.err ? '' : ' hidden') + '>' + esc(this.err) + '</p>';
    }

    // The coupon row of the offers card: "Enter coupon code" (opens the form) or the applied code.
    paintCoupon(code, c) {
      var box = this.querySelector('[data-dfx-coupon]');
      if (!box) return;
      var offers = this.cart.offers || [], offersHtml = '';
      // Automatic offers already on the cart (festive hampers): shown as applied.
      offers.forEach(function (o) {
        offersHtml += '<div class="dfx-cart__applied">' + IC_PCT_TEAL + '<span class="dfx-cart__applied-txt"><b>' + esc(String(o.t).toUpperCase()) +
          '</b> applied ' + (o.a > 0 ? '<span class="dfx-cart__pill">Saved ' + money(o.a) + '</span>' : '') + '</span></div>';
      });
      if (code) {
        var note;
        if (this.saved > 0) note = '<span class="dfx-cart__pill">Saved ' + money(this.saved) + '</span>';
        else if (c && blockedBy(c, this.cart.offers)) note = '<small class="dfx-cart__warn">Not valid with ' + esc(blockedBy(c, this.cart.offers)) + '</small>';
        else if (c && this.cart.total < c.min) note = '<small class="dfx-cart__warn">Add ' + money(c.min - this.cart.total) + ' more to use it</small>';
        else note = '<small class="dfx-cart__muted">Applied at checkout</small>';
        box.innerHTML = offersHtml + '<div class="dfx-cart__applied">' + IC_PCT_TEAL + '<span class="dfx-cart__applied-txt"><b>' + esc(code.toUpperCase()) +
          '</b> applied ' + note + '</span><button type="button" class="dfx-cart__link" data-dfx-remove>Remove</button></div>';
        return;
      }
      var open = !!(this.formOpen || this.err), html = offersHtml;
      // Coupons marked "Show outside", biggest saving first, only when usable on this cart: saving() is 0 below the
      // minimum or next to an automatic offer the coupon doesn't combine with, so a hamper cart shows the applied
      // offer and no Apply bar.
      var total = this.cart.total, applyText = String(this.cfg.applyText || '[title] · save [save]');
      this.cfg.coupons
        .filter(function (c) { return c.outside && saving(c, total, offers) > 0; })
        .sort(function (a, b) { return saving(b, total, offers) - saving(a, total, offers); })
        .forEach(function (b) {
          var line = applyText.replace('[title]', b.title || '').replace('[save]', money(saving(b, total, offers)));
          html += '<div class="dfx-cart__strip"><span class="dfx-cart__strip-ic">' + IC_TAG + '</span>' +
            '<span class="dfx-cart__strip-txt"><b>' + esc(String(b.code).toUpperCase()) + '</b><small>' + esc(line) + '</small></span>' +
            '<button type="button" class="dfx-cart__btn" data-dfx-apply="' + esc(b.code) + '">Apply</button></div>';
        });
      box.innerHTML = html + '<button type="button" class="dfx-cart__coupon-toggle" aria-expanded="' + open + '" data-dfx-coupon-toggle>' +
        '<span>' + IC_PCT_TEAL + 'Enter coupon code</span>' + IC_DOWN + '</button>' +
        (open ? '<div class="dfx-cart__coupon-form">' + this.formHtml(false) + '</div>' : '');
    }

    // Shopify checks the code and applies it on the cart itself (cart/update.js `discount`): the drawer then shows
    // Shopify's totals, and GoKwik checkout reads the code from the cart (checked 12 Oct 2026: applied once, same
    // total). A code Shopify marks not applicable is taken off again (the previous one goes back), with the reason.
    applyCode(raw, method) {
      var self = this, code = String(raw || '').trim().toUpperCase(), prev = this.code();
      this.err = '';
      if (!CODE_RE.test(code)) { this.err = 'Enter a valid coupon code'; return this.paint(); }
      return this.cartCall('/cart/update.js', { discount: code }).then(function (j) {
        if (!j) return;
        var ok = (j.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code && d.applicable; });
        if (ok) {
          setCookie(CODE_COOKIE, '');
          self.formOpen = false;
          self.track('cart_coupon_applied', { coupon_code: code, apply_method: method || 'typed', est_discount: rupees(self.saved) });
          if (!self.sheet.hidden) self.closeOffers();
          return;
        }
        return self.cartCall('/cart/update.js', { discount: prev }).then(function () { return self.whyNot(code); }).then(function (why) {
          self.err = why || code + ' is not valid for this cart';
          if (self.code()) { self.flash(self.err); self.err = ''; } else self.paint();   // the applied row has no room for it
          self.track('cart_coupon_rejected', { coupon_code: code, apply_method: method || 'typed', reason: why });
        });
      });
    }

    // Shopify only says "not applicable". GoKwik's validator (the one KwikCart asks) has the reason, e.g. "Add item(s)
    // worth Rs. 4361 more to avail this discount."; '' when it has none or cannot be reached.
    whyNot(code) {
      var shop = this.dataset.shop;
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return fetch(GK_VALIDATE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'x-shop-domain': shop },
            body: JSON.stringify({ cart: camel(cart), requestId: requestId(), platform: GK_PLATFORM, couponCode: code })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (j) { var d = (j && j.data) || {}; return d.isValid ? '' : String(d.errorMessage || '').slice(0, 160); })
        .catch(function () { return ''; });
    }

    // A code that is only in the discount_code cookie (a /discount/CODE link, or typed before 12 Oct 2026 when the
    // drawer kept codes there unchecked) goes onto the cart through the same check, once per visit.
    // ponytail: a cookie code the cart does not qualify for yet is not retried when the cart grows; retry on total change if that matters.
    carry(code) {
      var old = cookie(CODE_COOKIE).trim().toUpperCase();
      if (!old || code || !this.cart.count || !CODE_RE.test(old)) return;
      try {
        if (sessionStorage.getItem(CARRIED) === old) return;
        sessionStorage.setItem(CARRIED, old);
      } catch (e) {
        if (this.carried) return;
        this.carried = true;
      }
      setCookie(CODE_COOKIE, '');
      this.applyCode(old, 'carried');
    }

    removeCode() {
      var code = this.code();
      setCookie(CODE_COOKIE, '');
      this.err = '';
      return this.cartCall('/cart/update.js', { discount: '' }, ['cart_coupon_removed', { coupon_code: code.toUpperCase() }]);
    }

    /* ---------- offers sheet ---------- */
    openOffers() {
      this.sheet.hidden = false;
      this.loadOffers();
      this.paintOffers();
      this.track('cart_offers_viewed', { offer_tab: this.tab, offer_count: this.offerCount() });
      var x = this.sheet.querySelector('[data-dfx-offers-close]');
      if (x) x.focus();
    }

    closeOffers() {
      if (!this.sheet || this.sheet.hidden) return;
      this.sheet.hidden = true;
      var v = this.querySelector('[data-dfx-offers-open]');
      if (v && this.classList.contains('is-open')) v.focus();
    }

    offerCount() { return this.cfg.coupons.length + (this.gk ? this.gk.count : 0); }

    countBadge() {
      var n = this.offerCount();
      var el = this.querySelector('[data-dfx-offer-count]');
      if (!el) return;
      el.hidden = !n;
      el.textContent = n;
    }

    loadOffers() {
      if (!this.cfg.gokwik || !this.cart || !this.cart.count) return;
      var key = this.cart.total + ':' + this.cart.count;
      if (this.gkKey === key) return;
      this.gkKey = key;
      var self = this, shop = this.dataset.shop;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return fetch(GK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'x-shop-domain': shop },
            body: JSON.stringify({ cart: camel(cart), requestId: requestId(), platform: GK_PLATFORM })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (self.gkKey !== key) return;
          var d = j && j.statusCode === 200 && j.data;
          if (!d || (d.meta && d.meta.degraded)) { self.gk = null; }
          else {
            var t = d.tabs || {};
            // The UPI-EMI (Snapmint) schedule is not an offer: not shown, not counted.
            self.gk = {
              pay: ((t.paymentOffers || {}).groups || []).filter(function (g) { return g && g.offers && g.offers.length; }),
              emi: (t.emiCards || {}).banks || [],
              count: Math.max(0, (Number(d.meta && d.meta.totalOfferCount) || 0) - (t.emiUpi ? 1 : 0))
            };
          }
          self.countBadge();
          self.paintOffers();
        })
        .catch(function () {
          if (self.gkKey !== key) return;
          self.gk = null;
          self.gkKey = null;
          self.countBadge();
          self.paintOffers();
        });
    }

    paintOffers() {
      if (!this.sheet || this.sheet.hidden) return;
      var gk = this.gk;
      var has = { coupons: true, payment: !!(gk && gk.pay.length), emi: !!(gk && gk.emi.length) };
      if (!has[this.tab]) this.tab = 'coupons';
      var tab = this.tab;
      this.sheet.querySelectorAll('[data-dfx-tab]').forEach(function (b) {
        var k = b.getAttribute('data-dfx-tab');
        b.hidden = !has[k];
        b.setAttribute('aria-selected', k === tab ? 'true' : 'false');
        b.tabIndex = k === tab ? 0 : -1;
      });
      var banner = this.sheet.querySelector('[data-dfx-banner]');
      var text = (this.cfg.banner || {})[tab] || '';
      banner.hidden = !text;
      banner.innerHTML = IC_INFO + '<span>' + esc(text) + '</span>';
      var panel = this.sheet.querySelector('[data-dfx-tabpanel]');
      // GoKwik's data, GoKwik's credit: at the top of the two tabs it feeds.
      var powered = tab !== 'coupons' && this.cfg.powered && this.cfg.poweredLogo  // our own theme asset URL
        ? '<p class="dfx-cart__powered"><span>Powered by</span><img src="' + esc(this.cfg.poweredLogo) + '" alt="GoKwik" width="51" height="15"></p>' : '';
      panel.innerHTML = powered + (tab === 'payment' ? this.payHtml(gk.pay) : tab === 'emi' ? this.emiHtml(gk.emi) : this.couponsHtml());
    }

    couponsHtml() {
      var self = this, total = this.cart.total, offers = this.cart.offers, applied = this.code().toLowerCase();
      var list = this.cfg.coupons.map(function (c) {
        var s = saving(c, total, offers), on = String(c.code).toLowerCase() === applied, blocked = blockedBy(c, offers);
        var off = total < c.min || !!blocked;
        var note = s > 0 ? '<small class="dfx-cart__save">Save ' + money(s) + '</small>'
          : blocked ? '<small class="dfx-cart__muted">Not valid with ' + esc(blocked) + '</small>'
          : total < c.min ? '<small class="dfx-cart__muted">Add ' + money(c.min - total) + ' more to avail</small>' : '';
        var terms = String(c.terms || '').split(/\n+/).filter(Boolean);
        return '<div class="dfx-cart__coupon' + (off ? ' is-off' : '') + '"><div class="dfx-cart__coupon-main">' +
          '<b>' + esc(String(c.code).toUpperCase()) + '</b><span>' + esc(c.title) + '</span>' + note +
          (terms.length ? self.moreHtml(terms) : '') + '</div>' +
          (on ? '<button type="button" class="dfx-cart__btn is-ghost" data-dfx-remove>Remove</button>'
            : '<button type="button" class="dfx-cart__btn" data-dfx-apply="' + esc(c.code) + '"' + (off ? ' disabled' : '') + '>Apply</button>') +
          '</div>';
      }).join('');
      return this.formHtml(true) + list;
    }

    moreHtml(lines) {
      return '<button type="button" class="dfx-cart__more" aria-expanded="false" data-dfx-more>Know more ' + IC_DOWN + '</button>' +
        '<ul hidden>' + lines.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>';
    }

    payHtml(groups) {
      var self = this;
      return groups.map(function (g) {
        return '<div class="sh-h4 dfx-cart__group">' + esc(g.groupTitle) + '</div>' + g.offers.map(function (o) {
          var logo = https(o.logoUrl);
          var tnc = Array.isArray(o.tnc) ? o.tnc : String(o.tnc || '').split('||').filter(Boolean);
          return '<div class="dfx-cart__row"><span class="dfx-cart__logo">' + (logo ? '<img src="' + esc(logo) + '" alt="" loading="lazy">' : IC_PCT) + '</span>' +
            '<div class="dfx-cart__row-main"><b>' + esc(o.title) + '</b>' +
            (o.saveUpToAmount > 0 ? '<small class="dfx-cart__save">Save up to ' + money(Math.round(o.saveUpToAmount * 100)) + '</small>' : '') +
            (o.subtitle ? '<small class="dfx-cart__muted">' + esc(o.subtitle) + '</small>' : '') +
            (tnc.length ? self.moreHtml(tnc) : '') + '</div></div>';
        }).join('');
      }).join('');
    }

    emiHtml(banks) {
      var self = this;
      return banks.map(function (b) {
        var logo = https(b.logoUrl), name = String(b.bankName || ''), first = name.split(/\s+/)[0] || '';
        var mark = logo ? '<img src="' + esc(logo) + '" alt="" loading="lazy">'
          : (/\d/.test(name) || first.length < 3) ? IC_CARD : esc(first.slice(0, 5));
        var plans = Array.isArray(b.plans) ? b.plans : [];
        var tenures = Array.isArray(b.tenures) ? b.tenures : [];
        return '<div class="dfx-cart__row"><span class="dfx-cart__logo' + (logo ? '' : ' is-text') + '">' + mark + '</span>' +
          '<div class="dfx-cart__row-main"><span class="dfx-cart__row-head"><b>' + esc(name) + '</b>' +
          (b.noCost ? '<span class="dfx-cart__badge">0% interest</span>' : '') + '</span>' +
          (b.saveUpToAmount > 0 ? '<small class="dfx-cart__save">Save up to ' + money(Math.round(b.saveUpToAmount * 100)) + '</small>' : '') +
          (tenures.length ? '<span class="dfx-cart__tenures">' + tenures.map(function (t) { return '<span>' + esc(t) + ' mo</span>'; }).join('') + '</span>' : '') +
          (plans.length ? self.moreHtml(plans) : '') + '</div></div>';
      }).join('');
    }

    /* ---------- events ---------- */
    onClick(e) {
      var t = e.target, el;
      if ((el = t.closest('[data-dfx-close]'))) {
        e.preventDefault();
        return this.close(el.classList.contains('dfx-cart__overlay') ? 'overlay' : el.classList.contains('dfx-cart__x') ? 'x' : 'continue_shopping');
      }
      if ((el = t.closest('[data-dfx-qty]'))) return this.change(el.closest('[data-key]').getAttribute('data-key'), Number(el.getAttribute('data-dfx-qty')), el);
      if ((el = t.closest('[data-dfx-apply]'))) return this.applyCode(el.getAttribute('data-dfx-apply'), el.closest('[data-dfx-offers]') ? 'offers_sheet' : 'strip');
      if ((el = t.closest('[data-dfx-nav]'))) {
        var row = el.parentNode.firstElementChild;
        return row.scrollBy({ left: Number(el.getAttribute('data-dfx-nav')) * row.clientWidth * 0.8, behavior: 'smooth' });
      }
      if (t.closest('[data-dfx-coupon-toggle]')) {
        this.formOpen = !this.formOpen;
        this.err = '';
        this.paint();
        var inp = this.formOpen && this.querySelector('[data-dfx-coupon] input');
        if (inp) inp.focus();
        return;
      }
      if (t.closest('[data-dfx-remove]')) return this.removeCode();
      if (t.closest('[data-dfx-offers-open]')) return this.openOffers();
      if (t.closest('[data-dfx-offers-close]')) return this.closeOffers();
      if ((el = t.closest('[data-dfx-tab]'))) {
        var tab = el.getAttribute('data-dfx-tab');
        if (tab === this.tab) return;
        this.tab = tab;
        this.paintOffers();
        return this.track('cart_offers_viewed', { offer_tab: tab, offer_count: this.offerCount() });
      }
      if ((el = t.closest('[data-dfx-more]'))) {
        var open = el.getAttribute('aria-expanded') !== 'true';
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
        el.nextElementSibling.hidden = !open;
        return;
      }
      if ((el = t.closest('[data-dfx-fbt-pick]'))) return this.openPicker(el.closest('[data-dfx-fbt]'), false, el);
      if ((el = t.closest('[data-dfx-pick-opt]'))) return this.pickOption(Number(el.getAttribute('data-i')), el.getAttribute('data-v'));
      if (t.closest('[data-dfx-pick-close]')) return this.closePicker();
      if (t.closest('[data-dfx-pick-confirm]')) return this.confirmPicker();
      if ((el = t.closest('[data-dfx-fbt-add]'))) return this.add(el);
      if ((el = t.closest('[data-dfx-checkout]'))) return this.checkout(el);
    }

    onChange() {}

    /* ---------- size selector (PDP-style sheet) for "You may also like" products with options ---------- */
    openPicker(card, addAfter, trigger) {
      var data = card && readJson(card.querySelector('[data-dfx-fbt-data]'));
      if (!data) return;
      // Custom sizes need the dimensions typed on the product page: not offered here.
      data.variants = data.variants.filter(function (x) { return !x.o.some(function (val) { return /custom/i.test(val); }); });
      if (!data.variants.length) return;
      var cur = Number(card.querySelector('[data-dfx-fbt-add]').getAttribute('data-dfx-fbt-add'));
      var v = data.variants.filter(function (x) { return x.id === cur; })[0] || data.variants.filter(function (x) { return x.a; })[0];
      this.pick = { card: card, data: data, sel: v ? v.o.slice() : [], addAfter: addAfter, trigger: trigger || null };
      if (!this.picker) {
        this.picker = document.createElement('div');
        this.picker.className = 'dfx-cart__picker';
        this.querySelector('.dfx-cart__panel').appendChild(this.picker);
      }
      this.picker.hidden = false;
      this.paintPicker();
      var first = this.picker.querySelector('[aria-pressed="true"]') || this.picker.querySelector('[data-dfx-pick-confirm]');
      if (first) first.focus();
    }

    pickVariant() {
      var sel = this.pick.sel;
      return this.pick.data.variants.filter(function (x) {
        return x.o.every(function (val, i) { return val === sel[i]; });
      })[0] || null;
    }

    // A value in option i: keep the other choices where an available variant allows it, else the closest one.
    pickOption(i, val) {
      if (!this.pick) return;
      var sel = this.pick.sel, best = null, score = -1;
      this.pick.data.variants.forEach(function (x) {
        if (!x.a || x.o[i] !== val) return;
        var s = x.o.reduce(function (n, v, k) { return n + (v === sel[k] ? 1 : 0); }, 0);
        if (s > score) { best = x; score = s; }
      });
      if (best) this.pick.sel = best.o.slice();
      this.paintPicker();
      var b = this.picker.querySelector('[data-i="' + i + '"][aria-pressed="true"]');
      if (b) b.focus();
    }

    paintPicker() {
      var p = this.pick, d = p.data, sel = p.sel, v = this.pickVariant();
      var groups = d.options.map(function (o, i) {
        // Like the PDP popup: a later option only lists values that exist with the choices above it.
        var fits = function (x) { for (var k = 0; k < i; k++) if (x.o[k] !== sel[k]) return false; return true; };
        var vals = o.v.filter(function (val) { return d.variants.some(function (x) { return x.o[i] === val && (i === 0 || fits(x)); }); });
        return '<div class="dfx-cart__picker-group"><b>' + esc(o.n) + '</b><div class="dfx-cart__picker-opts">' +
          vals.map(function (val) {
            var ok = d.variants.some(function (x) { return x.a && x.o[i] === val && (i === 0 || fits(x)); });
            return '<button type="button" class="dfx-cart__picker-opt" data-dfx-pick-opt data-i="' + i + '" data-v="' + esc(val) + '" aria-pressed="' +
              (sel[i] === val) + '"' + (ok ? '' : ' disabled') + '>' + esc(val) + '</button>';
          }).join('') + '</div></div>';
      }).join('');
      var price = v ? '<span class="dfx-cart__price">' + money(v.p) + '</span>' +
        (v.c > v.p ? '<s class="dfx-cart__strike">' + money(v.c) + '</s><span class="dfx-cart__off">' + Math.round((v.c - v.p) * 100 / v.c) + '% off</span>' : '') : '';
      // Sleepyhead's PDP popup (snippets/variant-pop-modal.liquid): "Select options", Close + Apply.
      this.picker.innerHTML = '<div class="dfx-cart__picker-bg" data-dfx-pick-close></div>' +
        '<div class="dfx-cart__picker-sheet" role="dialog" aria-modal="true" aria-label="Select options">' +
        '<div class="dfx-cart__picker-head"><div class="sh-h3">Select options</div><small>' + esc(d.title) + '</small></div>' +
        '<div class="dfx-cart__picker-body">' + groups + '</div>' +
        '<div class="dfx-cart__picker-foot"><div class="dfx-cart__picker-price">' + price + '</div>' +
        '<div class="dfx-cart__picker-btns"><button type="button" class="dfx-cart__picker-btn is-close" data-dfx-pick-close>Close</button>' +
        '<button type="button" class="dfx-cart__picker-btn" data-dfx-pick-confirm' + (v && v.a ? '' : ' disabled') + '>' +
        (p.addAfter ? 'Add to cart' : 'Apply') + '</button></div></div></div>';
    }

    confirmPicker() {
      var p = this.pick, v = p && this.pickVariant();
      if (!v || !v.a) return;
      this.setFbtVariant(p.card, v);
      p.card.dfxChosen = true;
      var addAfter = p.addAfter, card = p.card;
      this.closePicker();
      if (addAfter) this.add(card.querySelector('[data-dfx-fbt-add]'));
    }

    closePicker() {
      if (!this.pick) return;
      var trig = this.pick.trigger;
      this.pick = null;
      if (this.picker) { this.picker.hidden = true; this.picker.innerHTML = ''; }
      if (trig && trig.isConnected) trig.focus();
    }

    setFbtVariant(card, v) {
      var price = v.p, cmp = v.c;
      var label = card.querySelector('[data-dfx-fbt-label]');
      if (label) label.textContent = v.t;
      card.querySelector('[data-dfx-fbt-price]').textContent = money(price);
      var s = card.querySelector('[data-dfx-fbt-compare]');
      s.hidden = !(cmp > price);
      s.textContent = money(cmp);
      var off = card.querySelector('[data-dfx-fbt-off]');
      off.hidden = !(cmp > price);
      off.textContent = cmp > price ? Math.round((cmp - price) * 100 / cmp) + '% off' : '';
      card.querySelector('[data-dfx-fbt-add]').setAttribute('data-dfx-fbt-add', v.id);
    }

    /* ---------- cart calls ---------- */
    // ev = [event name, params]: tracked once the cart has accepted the change.
    cartCall(url, body, ev) {
      var self = this;
      body.sections = [this.dataset.section];
      body.sections_url = location.pathname;
      this.classList.add('is-busy');
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body, function (k, v) { return k === 'retried' ? undefined : v; })
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j && j.status && body.id && !body.retried && /no valid id|line parameter|cannot find/i.test(String(j.description || j.message || ''))) {
            return self.retryStale(url, body, ev);
          }
          if (j && j.status && j.description) { self.flash(j.description); self.refresh(); return null; }
          var before = self.cart ? self.cart.count : 0;
          var html = j && j.sections && j.sections[self.dataset.section];
          if (html) self.apply(html); else self.refresh();
          if (ev) self.track(ev[0], ev[1]);
          if (before > 0 && html && self.cart.count === 0) self.track('cart_cleared', { items_removed: before });
          publishCart(j);
          return j;
        })
        .catch(function () { self.refresh(); })
        .finally(function () { self.classList.remove('is-busy'); });
    }

    // The line was re-keyed (e.g. dfx-combo-offer swapped gift properties) after the drawer last rendered: find the
    // same variant (same gift parent) in the cart now and send the change again; otherwise just show the fresh cart.
    retryStale(url, body, ev) {
      var self = this, vid = String(body.id).split(':')[0];
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var same = (c.items || []).filter(function (i) { return String(i.variant_id) === vid; });
        // Clickable lines are cards, never gift rows: prefer the line that is not a gift.
        if (same.length > 1) {
          var own = same.filter(function (i) { var p = i.properties || {}; return !p._hamper_for && !p._combo_for; });
          if (own.length) same = own;
        }
        if (!same.length) { self.refresh(); return null; }
        var b = Object.assign({}, body, { id: same[0].key, retried: true });
        delete b.sections; delete b.sections_url;
        return self.cartCall(url, b, ev);
      }).catch(function () { self.refresh(); return null; });
    }

    change(key, qty, btn) {
      if (!key || qty < 0) return;
      var line = null;
      this.querySelectorAll('[data-key]').forEach(function (c) { if (c.getAttribute('data-key') === key) line = c; });
      var from = line ? Number(line.dataset.qty) : 0;
      var ev = qty === 0 ? ['cart_item_removed', { remove_method: btn && btn.classList.contains('dfx-cart__rm') ? 'trash' : 'qty_minus' }]
        : [qty > from ? 'cart_quantity_increased' : 'cart_quantity_decreased', {}];
      if (line) Object.assign(ev[1], cardItem(line, Math.abs(from - qty)), { from_qty: from, to_qty: qty });
      // Removing a product removes the gifts shown in its card in the same request (one cart update, so the hamper
      // script never sees orphaned gifts to turn into paid lines). Pooled gift lines lose only this card's share.
      if (qty === 0 && this.cfg.removeGifts) {
        var card = null;
        this.querySelectorAll('[data-key]').forEach(function (c) { if (c.getAttribute('data-key') === key) card = c; });
        var gifts = card && card.querySelector('[data-gifts]');
        var list = gifts ? gifts.getAttribute('data-gifts').split(',').filter(Boolean) : [];
        if (list.length) {
          var updates = {};
          updates[key] = 0;
          list.forEach(function (g) {
            var p = g.split('|'), k = p[0], n = Number(p[1]) || 0, q = Number(p[2]) || 0;
            updates[k] = Math.max(0, (k in updates ? updates[k] : q) - n);
          });
          return this.cartCall('/cart/update.js', { updates: updates }, ev);
        }
      }
      return this.cartCall('/cart/change.js', { id: key, quantity: qty }, ev);
    }

    add(btn) {
      var id = Number(btn.getAttribute('data-dfx-fbt-add'));
      if (!id) return;
      // A product with sizes: the shopper picks one before it goes in the cart.
      var card = btn.closest('[data-dfx-fbt]');
      if (card && !card.dfxChosen && card.querySelector('[data-dfx-fbt-data]')) return this.openPicker(card, true, btn);
      btn.disabled = true;
      return this.cartCall('/cart/add.js', { items: [{ id: id, quantity: 1 }] }, card ? ['cart_upsell_item_added', this.fbtItem(card, id)] : null);
    }

    // Item fields of a "You may also like" card; rec_source = complementary / related (Search & Discovery) or manual.
    fbtItem(card, id) {
      var data = readJson(card.querySelector('[data-dfx-fbt-data]'));
      var v = data && data.variants.filter(function (x) { return x.id === id; })[0];
      var price = v ? v.p : Math.round(Number(card.querySelector('[data-dfx-fbt-price]').textContent.replace(/[^0-9.]/g, '')) * 100);
      return { item_id: String(id), product_id: card.getAttribute('data-pid') || '', item_name: card.querySelector('.dfx-cart__fbt-name').textContent.trim(),
        item_variant: v ? variantName(v.t) : '', price: rupees(price), quantity: 1,
        position: Array.prototype.indexOf.call(card.parentNode.children, card) + 1, rec_source: card.getAttribute('data-src') || 'manual', picker_used: !!card.dfxChosen };
    }

    flash(msg) {
      var body = this.querySelector('.dfx-cart__scroll');
      if (!body) return;
      var p = document.createElement('p');
      p.className = 'dfx-cart__flash';
      p.setAttribute('role', 'alert');
      p.textContent = msg;
      body.prepend(p);
      setTimeout(function () { p.remove(); }, 4000);
    }

    // GoKwik checkout (merchant.integration.js, loaded by gokwik.liquid; it reads the coupon cookie). Shopify
    // checkout if GoKwik never loaded, or for visitors outside India (gokwik.liquid's international flow sets the flag).
    checkout(btn) {
      var gk = typeof window.onCheckoutClick === 'function' && !window.dfxShopifyCheckout;
      this.track('cart_checkout_clicked', { coupon_code: this.code().toUpperCase(), checkout_route: gk ? 'gokwik' : 'shopify' });
      if (gk) return window.onCheckoutClick(btn);
      location.href = '/checkout';
    }

    resetCheckout() {
      var b = this.querySelector('[data-dfx-checkout]');
      if (!b) return;
      b.disabled = false;
      b.style.cursor = '';
    }
  }

  customElements.define('dfx-cart', DfxCart);
})();
